angular.module('app.directives').directive('vpReminders', () => ({
    restrict: 'E',

    scope: {
        task: '=',
    },

    controller($scope, $timeout, $translate, $filter, notify, api, formValidator) {
        $scope.loaded = false;
        $scope.reminders = [];
        $scope.currentReminder = {};
        $scope.repeatOptions = [
            { value: 'day', label: $translate.instant('reminders.day') },
            { value: 'week', label: $translate.instant('reminders.week') },
            { value: 'month', label: $translate.instant('reminders.month') },
            { value: 'year', label: $translate.instant('reminders.year') },
            { value: 'days', label: $translate.instant('reminders.days') },
        ];

        const fv = formValidator('#ReminderForm', $scope);

        $scope.refresh = (clearCache) => {
            const path = `reminders/task/${$scope.task.id || ''}`;
            $scope.loaded = false;

            const model = api(path);

            if (clearCache) {
                model.clearCache();
            }

            model.list().then(
                (response) => {
                    $scope.reminders = response.data;
                    $scope.loaded = true;
                },
                () => {
                    $scope.loaded = true;
                }
            );
        };

        $timeout(() => {
            $scope.refresh();
        });

        $scope.addReminder = () => {
            const reminderName = ($scope.task.category ? $translate.instant($scope.task.category.key) + ': ' : '') + $scope.task.name;

            $scope.currentReminder = {
                id: 0,
                task_id: $scope.task.id,
                name: reminderName,
                repeat: 'day',
                repeat_by: 1,
                start_from: moment().format('YYYY-MM-DD'),
                until: moment().format('YYYY-MM-DD'),
                at_time: '08:00',
            };
        };

        $scope.editReminder = (id) => {
            $scope.currentReminder = $filter('getById')($scope.reminders, id) || { id: 0 };
        };

        $scope.removeReminder = (id) => {
            UIkit.modal.confirm(
                $translate.instant('sure_to_remove'),
                () => {
                    const info = notify.info($translate.instant('removing'));
                    notify.global(1);

                    api(`reminders/delete/${id}`)
                        .post({})
                        .then((response) => {
                            info.close();
                            notify.success($translate.instant('removed'));
                            notify.global(0);

                            $scope.refresh();
                        });
                },
                {
                    labels: {
                        Ok: $translate.instant('yes'),
                        Cancel: $translate.instant('cancel'),
                    },
                }
            );
        };

        $scope.saveReminder = () => {
            if (!fv.isValid()) {
                return;
            }

            const info = notify.info($translate.instant('saving'));
            notify.global(1);

            api('reminders')
                .post($scope.currentReminder)
                .then((response) => {
                    $scope.currentReminder = response;

                    info.close();
                    notify.success($translate.instant('saved'));
                    notify.global(0);

                    $scope.refresh();
                });
        };
    },

    templateUrl: '/app/tasks/reminders.html',
}));
